<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/invitees/edit">{{lang.LBL_ADD_INVITEE}}</router-link></li>
        <li><router-link to="/modules/invitees">{{lang.LBL_VIEW_INVITEE}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/Invitees/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
